import ContentBlocks from './index';
import type { Block } from './BlockLoader';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: any;
  field?: string;
  config?: unknown;
};

const BlockLoaderNonFields = ({
  entry,
  field = '',
  config = null,
}: Props): JSX.Element => {
  return (
    <>
      {entry[field].items.map((block: Block, i: number) => {
        if (!block || !block.__typename || block.disableLocale) {
          return null;
        }

        return (
          <ContentBlocks
            key={i}
            type={block.__typename}
            fields={block}
            config={config}
          />
        );
      })}
    </>
  );
};

export default BlockLoaderNonFields;
